import { UcoastEl } from '@/scripts/core/UcoastEl'
import { getAttributeOrThrow, qsRequired } from '@/scripts/core/global'
import { type SywmAddOptions } from '@/scripts/swym-init'

export class WishlistButton extends UcoastEl {
	static htmlSelector = 'wishlist-button'
	button: HTMLButtonElement
	onSuccessCallback: (addedListItem: boolean) => void
	onErrorCallback: (error: string) => void

	constructor() {
		super()
		this.button = qsRequired('button', this)
		this.onSuccessCallback = this.onSuccess.bind(this)
		this.onErrorCallback = this.onError.bind(this)

		this.button.addEventListener('click', this.onClick.bind(this))
		void this.load()
	}

	onClick() {
		if (!window.UcoastSwym) {
			throw new Error('Swym not loaded')
		}
        console.log('cliq')
		window.UcoastSwym.addItemCallback(
			this.getSwymOptions(),
			this.onSuccessCallback,
			this.onErrorCallback
		)
	}

	onSuccess(addedListItem: boolean) {
		if (addedListItem) {
			this.button.classList.add('active')
		} else {
			this.button.classList.remove('active')
		}
		if (window.UcoastSwym) {
			console.log('wishlists', window.UcoastSwym.wishlists)
		}
	}
	onError(error: string) {
		console.error('Swym Add to Wishlist failed')
		console.error(error)
	}

	getSwymOptions(): SywmAddOptions {
		const epi = parseInt(getAttributeOrThrow('data-epi', this))
		const empi = parseInt(getAttributeOrThrow('data-empi', this))
		const du = getAttributeOrThrow('data-du', this)
		return {
			epi,
			empi,
			du,
		}
	}

	override connectedCallback() {
		super.connectedCallback()
	}

	async load() {
		if (!window.SwymCallbacks) {
			window.SwymCallbacks = []
		}
	}
}
